<div class="input-date-time-picker" [formGroup]="inner">
  <nimbus-input-date-picker
    class="input-date-time-picker-date"
    formControlName="date"
    [id]="id + '_date'"
    [required]="required"
    [label]="label"
  ></nimbus-input-date-picker>
  <nimbus-input-time-picker
    class="input-date-time-picker-time"
    formControlName="time"
    [id]="id + '_time'"
    [required]="required"
    format="HH:mm"
  ></nimbus-input-time-picker>
</div>
